export enum TaskStatusEnum {
  PENDING_CLEANING = "pending_cleaning",
  PENDING_CLASSIFICATION = "pending_classification",
  PENDING_ENTITY_MAPPING = "pending_entity_mapping",
  PENDING_PARAMETER_MAPPING = "pending_parameter_mapping",
  PENDING_MISSING_DATA_CHECKS = "pending_missing_data_checks",
  PENDING_VARIANCE_CHECKING = "pending_variance_checking",
  PENDING_CALCULATION_PREVIEW = "pending_calculation_preview",
  PENDING_EMISSIONS_CALCULATION = "pending_emissions_calculation",
  ESCALATED_VARIANCE_CHECKS_TO_MANAGER = "escalated_variance_checks_to_manager",
  ESCALATED_VARIANCE_CHECKS_TO_SUBMITTER = "escalated_variance_checks_to_submitter",
  ESCALATED_MISSING_DATA_CHECKS_TO_MANAGER = "escalated_missing_data_checks_to_manager",
  ESCALATED_MISSING_DATA_CHECKS_TO_SUBMITTER = "escalated_missing_data_checks_to_submitter",
  COMPLETE = "complete",
}

export type TaskProcessingStage =
  | TaskStatus
  | "draft"
  | "reopened"
  | "validation_failed"
  | "validating";

export type TaskStatus = `${TaskStatusEnum}`;

export const QUEUE_VALUES = {
  ACTION_REQUIRED: "action_required",
  CUSTOMER_ACTION: "customer_action",
  SYSTEM_TASK: "system_action",
  NO_ACTION_REQUIRED: "no_action_required",
} as const;

export type QueueValue = typeof QUEUE_VALUES[keyof typeof QUEUE_VALUES];

export type Task = {
  id: string;
  status: TaskStatus;
  organisation: string;
  organisationId: string;
  reportingYear: string;
  submissionGroup: string;
  submissionSlot: string;
  assignee: string;
  created: string;
  modified: string;
};

export type TaskByOrganisation = {
  assignee: string | null;
  created: string;
  emissionStatus: "partial" | "full" | "none";
  filterStatus: QueueValue;
  hasErrorLogs: boolean;
  id: string;
  locked: boolean;
  modified: string;
  reportingYear: string;
  status: TaskProcessingStage;
  submissionGroup: string;
  submissionSlot: string;
};
